export default {"src":"/_next/static/media/managed-services.4e751432.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};